<template>
  <div class="table-hover  mb-1 table-page-responsive table-ellipsis">
    <table class="table align-middle">
      <thead class="table-light">
        <tr>
          <th
            scope="col"
            v-for="(th, i) in column"
            :key="i"
            style="padding-left: 20px"
            :style="th.width && { width: th.width }"
          >
            {{ th.title }}
          </th>
          <th>
            {{this.$t('page.expert-system.ThresholdManagement')}}
          </th>
          <th>
            {{this.$t('page.expert-system.ExpertStatement')}}
          </th>
        </tr>
      </thead>
      <tbody class="list">
        <tr v-for="(item, index) in showTableData" :key="index">
          <td
            v-for="th in column"
            :key="th.dataIndex"
            scope="col"
            style="padding-left: 20px"
          >
            <div
              v-if="th.dataIndex == 'warn_status'"
              :class="`status-icon status-icon-${
                item[th.dataIndex] || 'unknown'
              }`"
            ></div>
            <span v-else-if="th.dataIndex == 'ts'">
              {{
                (item[th.dataIndex] &&
                  moment(item[th.dataIndex])
                    .tz($tz)
                    .format("YYYY-MM-DD HH:mm:ss")) ||
                "-"
              }}
            </span>
            <span
              v-else-if="th.dataIndex == 'curvalue'"
              v-text="valueFormatter1(item[th.dataIndex])"
            ></span>
            <span v-else> {{ item[th.dataIndex] }} </span>
          </td>

          <td>
            <div
              class="fs-20 text-primary drop-button position-relative"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              data-bs-offset="10,20"
            ></div>
            <div
              class="dropdown-menu pt-0 pb-0 drop-menu"
              aria-labelledby="dropdownMenuOffset"
            >
              <Threshold
                :threshold="item.threshold"
                v-bind="$attrs"
                :instance_id="item.instance_id"
                :measure_id="item.id"
                :recordThreshold="item.recordThreshold"
                :currentInfo="currentInfo"
              ></Threshold>
            </div>
          </td>
          <td>
            <i
              class="fs-20 ri-message-2-fill text-primary"
              @click="handleExpertExplain(item)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Threshold from "./threshold.vue";
import { progressChart } from "../../utils/chart";
import moment from "moment";
import "moment-timezone";
import { valueFormatter1 } from "../../utils/common";
export default {
  emits: ["update:singleData","update:isShowExpertExplain",],
  props: {
    currentInfo: Object,
    singleData: Object,
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    column: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: { Threshold },
  data() {
    return {
      showTableData: [],
      showAllChecked: false,
      states: {
        unknown: "#9ca3bf",
        error: "#ED5E5E",
        health: "#13C56B",
        "sub-health": "#f7b84b",
      },
    };
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.showTableData = newVal;
        // this.$nextTick(() => {
        //   this.showTableData.map((item) => {
        //     progressChart({
        //       chartDom: document.getElementById(item.eqId + item.key),
        //       dataList: item,
        //       lineColor: this.states[item["warn_status"]],
        //     });
        //   });
        // });
      },
      deep: true,
      immediate:true
    },
    allCheckedType: {
      handler(newVal) {
        this.showAllChecked = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    valueFormatter1,
    moment,
    threshold(item) {
      let o1 = Number(item.operationThresholdLow);
      let o2 = Number(item.operationThresholdHigh);
      let s1 = Number(item.standardThresholdLow);
      let s2 = Number(item.standardThresholdHigh);
      let flag = true;
      if (s1 < o1 || s2 > o2) {
        flag = false;
      }

      return flag;
    },
    handleExpertExplain(item) {
      this.$emit("update:singleData", item);
      this.$emit("update:isShowExpertExplain", true);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.drop-button::after {
  position: absolute;
  top: -10px;
  width: 1.1rem;
  height: 1.1rem;
  content: "";
  background-repeat: no-repeat;
  background-size: 1.1rem;
}
.drop-button[aria-expanded="true"]::after { 
  background-image: url("../../assets/images/indeterminate-icon.svg");
}

.drop-button[aria-expanded="false"]::after {
  background-image: url("../../assets/images/plus-icon.svg");
}
</style>
